import template from './organizationListItem.html';

export default angular
  .module('main.organizationsList.listItem', [])

  .directive('organizationListItem', () => {
    return {
      restrict: 'E',
      template: template,
      replace: true,
      scope: {
        org: '=',
        onEdit: '&',
        onDelete: '&'
      },
      controller: (
        $scope,
        $rootScope
      ) => {
        angular.extend($scope, {
          copyToClipboard: $rootScope.copyToClipboard,
        });
      }
    };
  })
  .name;
